var _a;
import Cookies from 'js-cookie';
import { GA_EXPERIMENT_SLOTS, } from './ga.service.types';
var SLOT_NAMES_TO_ACTIVE_AB_TESTS = (_a = {},
    _a[GA_EXPERIMENT_SLOTS.ALPHA] = 'smf-102__progressive_disclosure',
    _a[GA_EXPERIMENT_SLOTS.BETA] = null,
    _a[GA_EXPERIMENT_SLOTS.GAMMA] = null,
    _a[GA_EXPERIMENT_SLOTS.DELTA] = null,
    _a[GA_EXPERIMENT_SLOTS.EPSILON] = null,
    _a);
var GaServiceHelpers = /** @class */ (function () {
    function GaServiceHelpers() {
    }
    GaServiceHelpers.makeEmptyGAExperimentResults = function () {
        var slotNames = Object.values(GA_EXPERIMENT_SLOTS);
        return slotNames.reduce(function (acc, slotName) {
            acc[slotName] = {
                name: null,
                variation: null,
            };
            return acc;
        }, {});
    };
    GaServiceHelpers.mapGAMetaToExperimentResults = function (meta) {
        var features = meta.ABTests.features;
        var baseGAExperimentResults = this.makeEmptyGAExperimentResults();
        Object.entries(SLOT_NAMES_TO_ACTIVE_AB_TESTS).forEach(function (_a) {
            var key = _a[0], activeTestName = _a[1];
            var slotName = key;
            if (activeTestName === null) {
                return;
            }
            var variation = features[activeTestName];
            if (typeof variation === 'undefined') {
                return;
            }
            // rewrite empty state of active slot, if was configured
            baseGAExperimentResults[slotName] = {
                name: activeTestName,
                variation: variation,
            };
        });
        return baseGAExperimentResults;
    };
    GaServiceHelpers.getPlacementIdFromSmavaCookies = function () {
        return Cookies.get('placementIdBaufi');
    };
    return GaServiceHelpers;
}());
export { GaServiceHelpers };
